var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.loaderClasses,staticStyle:{"margin":"0"}},[_c('div',{staticClass:"checkmark draw",style:(_vm.checkStyles)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }